import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import type { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'reports/contact/health';

export function useContactHealthReportQuery({
	enabled = true,
	impersonationContext,
	source,
}: {
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
	source?: string | null;
} = {}) {
	const userSession = useUserSession();
	const accountId = impersonationContext?.account?.id;
	const userId = impersonationContext?.user?.id;
	return useQuery({
		enabled,
		queryKey: [BASE_QUERY_KEY, accountId, userId, source ?? null],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.IContactHealthReport>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					queryParams: { source },
					urlPath: 'reports/contact/health',
				}),
				'GET'
			),
		// Keeps the last filter's report while the next one loads so the page can show it as updating, never across accounts.
		placeholderData: (previousData, previousQuery) =>
			previousQuery?.queryKey[1] === accountId ? previousData : undefined,
		meta: {
			errorLogging: { action: 'ContactHealthReportQuery-Error', category: 'ContactHealthReport' },
			toastErrorMessage: 'Failed to load the contact health report.',
		} satisfies LevStandardQueryMeta,
	});
}
